import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { setCreditAmount, setSalesTaxConsole } from '../../redux/modules/salestaxes';

class Credit extends Component {
  constructor(props) {
    super(props);
    this.onEnterText = this.onEnterText.bind(this);
  }

  onEnterText(event) {
    const value = event.target.value;
    this.props.setCreditAmount(value);
  }

  render() {
    const { creditAmount } = this.props;
    return (
      <div className="Row Title-feeRow">

        <input
          id="Anycredit"
          data-id="salesTaxCreditAmount"
          data-tooltip="Any credit allowed on Vehicle Taxable Purchase Price, less trade-in"
          type="number"
          value={creditAmount}
          onChange={this.onEnterText}
          className="Row-total Row-editableTotal"
        />

        <b className="no-print">Enter Sales Tax Already Paid</b>
        <b className="print-label print-only">Sales Tax Already Paid</b>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    creditAmount: state.salestaxes.creditAmount,
  };
};

Credit.propTypes = {
  creditAmount: PropTypes.number.isRequired,
  setCreditAmount: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { setCreditAmount, setSalesTaxConsole })(Credit);



// WEBPACK FOOTER //
// ./src/containers/salestaxes/Credit.js